import { message } from "antd";
import { useMutation } from "@tanstack/react-query";
import { Company } from "@rumble-it/common-lib/types/models/Company.interface";
import { createCompany } from "../../../lib/api/resources/companies";
import { useNavigate } from "react-router-dom";
import { CompanyFormCard } from "./components/CompanyForm";

export const CompanyCreate = () => {
  const navigate = useNavigate();

  const createCompanyMutation = useMutation({
    mutationFn: (data: Partial<Company>) => createCompany(data),
    onSuccess: () => {
      navigate("/companies");
      message.success("Bedrijf succesvol aangemaakt");
    },
  });

  return (
    <div>
      <CompanyFormCard mutation={createCompanyMutation} />
    </div>
  );
};
